import * as React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { observer } from 'mobx-react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import FooterLink from './components/Link/Link';
import TrustBox from './TrustBox';
import Newsletter from '../Newsletter';
import SocialLinks from './components/SocialLinks';
import { generateBottomNavigation } from './utils';
import { COPYRIGHT } from './const';
import Navigation from './components/Navigation';
// import cardLogos from './images/footer-light.png';
// import cardLogosWP from './images/footer-light.webp';

interface IFooterProps extends RouteComponentProps<{ language: string }> {
  navData?: any;
}

interface IFooterState {
  navData?: any;
}

@observer
class Footer extends React.Component<IFooterProps, IFooterState> {
  constructor(props: IFooterProps) {
    super(props);

    this.state = {
      navData: props.navData || {},
    };
  }

  public scrollTop() {
    scroll.scrollToTop();
  }

  public render() {
    return (
      <div>
        <footer className={'footer'}>
          <div className={'container'}>
            <div className={'footer__divider'} />
            <Navigation navigation={generateBottomNavigation(this.props.navData)} />
            <div className="footer__actions">
              <SocialLinks />
              <Newsletter title="Subscribe for product updates!" className="order-1 order-md-2" />
            </div>
            <div className={'footer__divider'} />
            <div className="cardLogos">
              {/* Tohle */}
              {/* <picture>
                <source srcSet={cardLogosWP} type="image/webp" />
                <img src={cardLogos} width={'500vw'} />
              </picture> */}
              {/* po zbuildění dá <picture><source type="image/webp"><img width="500vw"></picture> - chybí src */}
              {/* Nahrazeno tímto: */}
              <picture>
                <source srcSet={'/assets/images/footer/footer-light.webp'} type="image/webp" />
                <img src={'/assets/images/footer/footer-light.png'} width={'500vw'} />
              </picture>
            </div>
            <div className={'footer__divider'} />
            <TrustBox />
            {/* <div className={'footer__divider'} /> */}
            <div className="footer__bottom">
              {COPYRIGHT && <p className={'text-copyright'}>{COPYRIGHT}</p>}
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default withRouter(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx